import { AttendanceEvent } from "@/entities/attendanceEvent/AttendanceEventType"
import { TimeRange } from "./TimeRange"

export function _processAttendanceEvents(
   events: AttendanceEvent[],
   periodFrom: Date,
   periodTo: Date,
): TimeRange[] {
   if (events.length === 0) {
      return [
         {
            from: periodFrom,
            to: periodTo,
            type: "present",
            justified: true,
         },
      ]
   }

   // Sort events by from date (oldest first)
   events.sort((a, b) => a.from.getTime() - b.from.getTime())

   // Initialize ranges with a default event, bounded by period limits
   let ranges: TimeRange[] = [
      {
         from: periodFrom,
         to: periodTo,
         type: "present",
         justified: true,
      },
   ]

   // Process each event
   for (const event of events) {
      const newRanges: TimeRange[] = []

      for (const range of ranges) {
         // Skip if the current range is external (cannot be overridden)
         if (range.type === "external") {
            newRanges.push(range)
            continue
         }

         // If event completely overlaps the range
         if (event.from <= range.from && event.to >= range.to) {
            newRanges.push({
               from: range.from,
               to: range.to,
               type: event.type,
               justified: event.justified,
            })
         }

         // If event partially overlaps after range from
         else if (event.from > range.from && event.from < range.to) {
            // First part (before event), we keep the original range
            newRanges.push({
               from: range.from,
               to: event.from,
               type: range.type,
               justified: range.justified,
            })
            // Second part (overlapped)
            newRanges.push({
               from: event.from,
               to: new Date(Math.min(event.to.getTime(), range.to.getTime())),
               type: event.type,
               justified: event.justified,
            })
            // Third part (after event) if exists, we keep the original range
            if (event.to < range.to) {
               newRanges.push({
                  from: event.to,
                  to: range.to,
                  type: range.type,
                  justified: range.justified,
               })
            }
         }

         // If event partially overlaps before range to
         else if (event.to > range.from && event.to < range.to) {
            // First part (overlapped)
            newRanges.push({
               from: range.from,
               to: event.to,
               type: event.type,
               justified: event.justified,
            })

            // Second part (after event), we keep the original range
            newRanges.push({
               from: event.to,
               to: range.to,
               type: range.type,
               justified: range.justified,
            })
         }

         // If no overlap
         else {
            newRanges.push(range)
         }
      }

      ranges = newRanges
   }

   return ranges
}
